export default "__VITE_ASSET__Bti8scdf__"